import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { BaseGenericInputComponent } from '../base-generic-input/base-generic-input.component';

@Component({
    selector: 'mat-generic-decimal-input',
    templateUrl: './generic-decimal-input.component.html',
    styleUrls: [ '../base-generic-input/base-generic-input.component.scss', './generic-decimal-input.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: MatFormFieldControl,
            useExisting: GenericDecimalInputComponent,
        },
    ],
})
export class GenericDecimalInputComponent extends BaseGenericInputComponent<number> {

    constructor(
        @Optional()
        @Self()
        protected myNgControl: NgControl,
        protected myChangeDetectorRef: ChangeDetectorRef,
    ) {
        super(myChangeDetectorRef);

        if (this.myNgControl) {
            this.myNgControl.valueAccessor = this;
        }
    }

    public onInputDecimal(event: Event): void {
        if ((event as InputEvent).data === '.') {
            const target: HTMLInputElement = (event.target as HTMLInputElement);
            event.stopImmediatePropagation();
            event.preventDefault();
            const value: string = target.value.substring(0, target.selectionStart) + target.value.substring(target.selectionEnd, target.value.length - 1);
            target.value = `${value.substring(0, target.selectionStart)},${value.substring(target.selectionStart, value.length - 1)}`;
        }
    }

}
